// src/components/StatusBadge.jsx
// Bug 06 fix: "Approved" aur "In Progress" status styles add kiye.

import React from 'react';

const STATUS_STYLES = {
  // Milestone
  Upcoming: 'bg-gray-100 text-gray-600',
  Due: 'bg-amber-50 text-amber-700',
  Received: 'bg-green-50 text-green-700',
  Overdue: 'bg-red-50 text-red-700',
  // Approval-style
  Pending: 'bg-amber-50 text-amber-700',
  'pending': 'bg-amber-50 text-amber-700',
  Approved: 'bg-green-50 text-green-700',
  'approved': 'bg-green-50 text-green-700',
  Rejected: 'bg-red-50 text-red-700',
  'rejected': 'bg-red-50 text-red-700',
  Paid: 'bg-blue-50 text-blue-700',
  Cancelled: 'bg-gray-100 text-gray-500',
  'cancelled': 'bg-gray-100 text-gray-500',
  Reversed: 'bg-red-50 text-red-700',
  // Payroll batches
  'Pending Review': 'bg-amber-50 text-amber-700',
  'Pending Approval': 'bg-orange-50 text-orange-700',
  // Offboarding (Bug 06 fix)
  'In Progress': 'bg-blue-50 text-blue-700',
  Completed: 'bg-green-50 text-green-700',
  'completed': 'bg-green-50 text-green-700',
};

const StatusBadge = ({ status }) => {
  const style = STATUS_STYLES[status] || 'bg-gray-100 text-gray-600';
  return (
    <span className={'inline-flex items-center px-2.5 py-1 rounded-full text-xs font-medium ' + style}>
      {status}
    </span>
  );
};

export default StatusBadge;